/**
 * Whether the view options a surface carries say to hide the Nova control.
 *
 * The two eye utils in this folder answer the same question in different currencies. The task
 * table's `theEyeToColumns` returns a plain boolean per option, while the board's returns a
 * positive ordering index for a shown option and `0` for a hidden one. A surface that renders
 * cards is handed whichever of the two its page happens to use, so it cannot ask "is this shown"
 * without picking a side and being wrong on the other.
 *
 * Asking whether it is hidden is the question both can answer. Anything that is neither `0` nor
 * `false` — `undefined` above all — reads as shown, so a page that does not model the option at
 * all keeps the control rather than losing it to a preference nobody expressed.
 */
export const isNovaColumnHidden = (viewOptions?: {nova?: boolean | number} | null): boolean =>
	viewOptions?.nova === 0 || viewOptions?.nova === false;
